<template>
  <div class="bg-secondary main_summury">
    <div class="flex-container bg-dark">
      <!-- COMPRESSION MOLDS  -->
        <div class="compressionMolds">
          <div class="compress_heading">
            <h4>EXTRUDERS</h4>
          </div>
          <div class="compress_cotents">
              <extruder></extruder>
          </div>
        </div>
        <!-- INJECTION MOLD -->
        <div class="injectionMolds">
          <div class="Injection_heading">
            <h4>COMPRESSION MOULDS</h4>
          </div>
          <div class="Injection_cotents">
               <CompressionMold></CompressionMold>
          </div>
        </div>
    </div>
    <!-- COMPRESSION MOLDS -->
    <div class="flex-container bg-dark"> 
        <div class="extruder">
         <div class="extruder_heading">
            <h4>INJECTION MOULDS</h4>
          </div>
          <div class="extruder_cotents">
            <Injection-mold></Injection-mold>
          </div>
        </div>

        <div class="corrugator">
         <div class="corrugator_heading">
            <h4>CORRUGATORS</h4>
          </div>
          <div class="corrugator_cotents">
            <Corrugator></Corrugator>
          </div>
        </div>
    </div>
  </div>
</template>
<script>
import CompressionMold from './dashboard/mainDbFiles/CompressionMold.vue'
import InjectionMold from './dashboard/mainDbFiles/InjectionMold.vue'
import Extruder from './dashboard/mainDbFiles/Extruder.vue'
import Corrugator from './dashboard/mainDbFiles/Corrugator.vue'
// import GateWays from './gate_ways/GateWays.vue'
import http from '../services/http'
export default {
  data() {
    return {
      machines: [],
      current_config: '',
      old_config: '',
      userType: '',
      disabled: false,
      pollTimer: null
    }
  },
  components: {
    CompressionMold,
    InjectionMold,
    Corrugator,
    Extruder,
    // GateWays
  },
  
mounted() {
  this.getSystem();
  this.getUserDetails()
    if(this.userType == 'viewer')
  {
    this.disabled = true
  }
},

compressionMoldss() {
  return this.$store.state
},

beforeMount() {
 // this.$store.dispatch('fetchmachines')
  this.$store.dispatch('fetchAllProducts')
  this.$store.dispatch('fetchmachines')
},

created() {
  // Keep a handle so we can stop polling when the dashboard unmounts (e.g. on
  // logout). Previously this interval was never cleared, so every login stacked
  // another poller that kept firing stale-token requests in the background.
  this.pollTimer = setInterval(() => {
   this.$store.dispatch('fetchmachines')
  }, 120000)
},

beforeDestroy() {
  if (this.pollTimer) {
    clearInterval(this.pollTimer)
    this.pollTimer = null
  }
},

  methods: {
    getSystem() {
      http.get('/api/system-config')
        .then((res) => {
          this.current_config = res.data[0].system_config
        })
      },
    system_conf() {
      http.put('/api/system-config', { current_config: this.current_config })
        .catch((error) => {
          console.log(error)
        })
    },
    //GET USER DETAILS
    getUserDetails() {
      this.userType = localStorage.getItem('userType')
    },
    
    //DEBUG NOTIFICATION TEST
    notifications() {},
    //MODAL FUNCTIONS
    openModal(position) {
     document.getElementById('myModal').style.display = 'block'
     this.machine_name = document.getElementById('machine_name').value = position
    },
    closeModal() {
     document.getElementById('myModal').style.display = 'none'
    },
  }
}
</script>

<style scoped>
.main_summury {
  min-height: 85vh;
}

/* Top heading bar */
.heading {
  display: flex;
  align-items: center;
  height: auto;
  width: 100%;
  margin-top: 0;
  padding: 18px 22px !important;
}

.heading_header {
  width: 100% !important;
  overflow: visible !important;
}

.heading_header h1,
h1 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
  float: none;
  margin: 0;
  padding: 2px 0;
  line-height: 1.5;
  color: var(--text);
  text-transform: uppercase;
  letter-spacing: 0.04em;
  font-size: 18px !important;
  font-weight: 700;
}

h4 {
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: 0.04em;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 14px;
}

/* Card containers */
.flex-container {
  display: flex;
  gap: 20px;
  margin-top: 20px;
  width: 100%;
}

.flex-container > div {
  margin: 0;
  padding: 20px 22px;
  width: 50%;
}

.fa:hover {
  color: var(--text);
}

/* System-config select in the heading */
select {
  width: auto;
  min-width: 150px;
  height: 34px;
  font-size: 13px;
  color: var(--text);
  padding: 4px 12px;
  border-radius: var(--radius-sm);
}

/* Modal */
.modal-content {
  background-color: var(--surface);
  margin: 15% auto;
  padding: 20px;
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  width: 80%;
  color: var(--text);
}

@media only screen and (max-width: 1100px) {
  .flex-container {
    flex-direction: column;
  }
  .flex-container > div {
    width: 100%;
  }
}
</style>